import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M12 9C15.866 9 19 7.88071 19 6.5C19 5.11929 15.866 4 12 4C8.13401 4 5 5.11929 5 6.5C5 7.88071 8.13401 9 12 9Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19 12C19 13.1067 15.8889 14 12 14C8.11111 14 5 13.1067 5 12'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 7V17.7059C5 18.9753 8.11111 20 12 20C15.8889 20 19 18.9753 19 17.7059V7'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
